import apiClient from './client';

export interface BackgroundCheckSubmission {
  id: number;
  name: string;
  email: string;
  phone: string;
  backgroundCheckSubmitted: boolean;
  backgroundCheckSubmittedAt: string;
  backgroundCheckStatus: 'not_started' | 'started' | 'submitted' | 'received';
  backgroundCheckStatusUpdatedAt: string | null;
  backgroundCheckNotes: string | null;
  backgroundCheckData: {
    permissionGranted: boolean;
    fullName: string;
    dateOfBirth: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    hasPreviousAddress?: boolean;
    previousAddress?: string;
    previousCity?: string;
    previousState?: string;
    previousZipCode?: string;
  };
  createdAt: string;
  user?: {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
  };
}

export interface BackgroundCheckStats {
  not_started: number;
  started: number;
  submitted: number;
  received: number;
  total: number;
}

export interface BackgroundCheckListResponse {
  data: BackgroundCheckSubmission[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    pages: number;
  };
}

export const getBackgroundCheckSubmissions = async (params?: {
  status?: string;
  page?: number;
  limit?: number;
}): Promise<BackgroundCheckListResponse> => {
  const response = await apiClient.get('/background-check/submissions', { params });
  return response.data;
};

export const getBackgroundCheckSubmission = async (id: number): Promise<{ data: BackgroundCheckSubmission }> => {
  const response = await apiClient.get(`/background-check/submissions/${id}`);
  return response.data;
};

export const updateBackgroundCheckStatus = async (
  id: number,
  data: { status: string; notes?: string }
): Promise<{ message: string; data: any }> => {
  const response = await apiClient.patch(`/background-check/submissions/${id}/status`, data);
  return response.data;
};

export const getBackgroundCheckStats = async (): Promise<{ data: BackgroundCheckStats }> => {
  const response = await apiClient.get('/background-check/stats');
  return response.data;
};

export const getBackgroundCheckSSN = async (id: number): Promise<{ data: { ssn: string; candidateId: number; candidateName: string } }> => {
  const response = await apiClient.get(`/background-check/submissions/${id}/ssn`);
  return response.data;
};

export const getBackgroundCheckPreviousAddress = async (id: number): Promise<{ data: { previousAddress: string; previousCity: string; previousState: string; previousZipCode: string; candidateId: number; candidateName: string } }> => {
  const response = await apiClient.get(`/background-check/submissions/${id}/previous-address`);
  return response.data;
};

